import Model from "@/models/Model";

export default class Collection extends Model {
    resource() {
        return "collections";
    }

    baseURL() {
        return super.baseURL() + "/resourcecenter";
    }

    created_by() {
        return this.related?.user?.display_name ?? "";
    }

    created_date() {
        let date = new Date(this.created_at.date ?? this.created_at);
        return date.toLocaleDateString();
    }

    updated_date() {
        let date = new Date(this.updated_at.date ?? this.updated_at);
        return date.toLocaleDateString();
    }

    isLiked() {
        return this.related?.userlikes?.length > 0;
    }
}
